/**
 * Private module reserved for @coursera/cds-core package.
 */

import { createMediumSvgIcon } from '@core/utils';

export default createMediumSvgIcon('RadioUncheckedIcon', {
  large: (
    <circle
      cx="10"
      cy="10"
      fill="inherit"
      r="9.1666663"
      stroke="currentColor"
      strokeWidth="1.6666666667"
    />
  ),
});
